import React, { useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { useGetDashboardPublishLinkMutation } from "../../features/report/reportApiSlice";

const SharedDashboard = () => {
  const [iframeLoading, setIframeLoading] = useState(true);
  const [currentIframeLink, setCurrentIframeLink] = useState(null);
  const { id } = useParams();
  const [getDashboardPublishLink] = useGetDashboardPublishLinkMutation();

  React.useEffect(() => {
    if (!id) return;

    let isMounted = true;
    setIframeLoading(true);

    (async () => {
      try {
        const result = await getDashboardPublishLink(id).unwrap();
        if (isMounted && result?.data?.publish_link) {
          setCurrentIframeLink(`${result.data.publish_link}&embed=true`);
        } else if (isMounted) {
          setIframeLoading(false);
        }
      } catch (error) {
        console.log(error, "error");
        if (isMounted) setIframeLoading(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [id]);

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const shareToken = urlParams.get("shareToken");
    if (shareToken) {
      window.__SHARE_TOKEN__ = shareToken;
    }
  }, []);

  return (
    <div style={{ width: "100%", height: "calc(100vh - 65px)" }}>
      {iframeLoading && (
        <Stack
          sx={{
            color: "grey.500",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
          spacing={2}
          direction="row"
        >
          <CircularProgress color="inherit" disableShrink />
        </Stack>
      )}
      {currentIframeLink ? (
        <iframe
          src={currentIframeLink}
          title="Shared Dashboard"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          onLoad={() => setIframeLoading(false)}
        />
      ) : (
        !iframeLoading && <p>No dashboard to display</p>
      )}
    </div>
  );
};

export default SharedDashboard;
